import styled from 'styled-components';

interface BaseProps {
	active?: boolean;
}

export const Base = styled.button<BaseProps>`
	background: none;
	border: none;
	padding: 0 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	height: var(--navbar-height);
	border-radius: 0;
	border-bottom: ${({ active, theme }) =>
		active ? `2px solid ${theme.blue[500]}` : '2px solid transparent'};
	font-family: 'Inter', sans-serif;
	font-size: 14px;
	font-weight: ${({ active }) => (active ? 600 : 500)};
	color: ${({ theme }) => theme.gray[1000]};
	transition: background-color 0.2s ease;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.blue[500]};
		outline-offset: -2px;
	}
`;
